<template>
    <div class="login-container">
        <Message :message="message" :type="type" v-if="message !== null"></Message>
        <h1>{{$t('login-screen.title')}}</h1>
        <form class="login" @submit.prevent="login">
            <div class="inputs">
                <input :placeholder="$t('login-screen.email')" required v-model="email"/>
                <input :placeholder="$t('login-screen.password')" required type="password" v-model="password"/>
            </div>
            <div class="buttons">
                <button class="login-button" type="submit">{{$t('login-screen.login-button')}}</button>
                <router-link :to="{name: 'forgot-password'}">{{$t('login-screen.reset-password')}}</router-link>
            </div>

        </form>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/api/RepositoryFactory';
import { AccessForbidden } from '@/api/user/erros';
import Message from '@/components/helpers/Message';

const UserRepository = RepositoryFactory.get('users');
const GroupsRepository = RepositoryFactory.get('groups');
const SalonsRepository = RepositoryFactory.get('salons');
const DevicesRepository = RepositoryFactory.get('devices');
const ConfigurationRepository = RepositoryFactory.get('configuration');

export default {
  components: { Message },
  data() {
    return {
      email: '',
      password: '',
      message: null,
      type: 'error',
    };
  },
  methods: {
    async login() {
      const { email } = this;
      const { password } = this;
      try {
        const token = await UserRepository.login({ username: email, password });
        this.$store.commit('set_store_state', false);
        await this.$store.dispatch('setToken', token);
        const configuration = await ConfigurationRepository.getConfiguration(token);
        await this.$store.dispatch('setConfig', configuration);
        const user = await UserRepository.getUser(token);
        const availableGroups = await GroupsRepository.getContextualGroups(token);
        if (availableGroups.length === 0) {
          availableGroups.push({ id: 0, name: this.$t('noGroups') });
        }
        user.groups = availableGroups;
        await this.$store.dispatch('setUser', { user });
        try {
          const salons = await SalonsRepository.getShopsGroup(token, this.$store.getters.selectedGroup.id);
          await this.$store.dispatch('setSalons', salons);
        } catch (salonsError) {
          console.log(salonsError);
        }
        if ((this.$store.getters.role === 'ADMINISTRATOR' || this.$store.getters.role === 'OPTIGUARD') && availableGroups.length > 0) {
          const devices = await DevicesRepository.getDevices(token, this.$store.getters.selectedGroup.id);
          await this.$store.dispatch('setDevices', devices);
        }
        this.$store.commit('set_store_state', true);
        this.$store.commit('set_expired', false);
        this.$router.push('/dashboard/');
      } catch (error) {
        if (error instanceof AccessForbidden) {
          this.message = this.$t('login-screen.errors.wrongData');
        } else {
          this.message = this.$t('login-screen.errors.error');
        }
      }
    },
  },

};
</script>

<style scoped lang="scss">
    .login-container {
        width: 500px;
        margin: 200px auto;
        margin-bottom: 0;
        @include media('<540px') {
            width: 90%;
        }

        h1 {
            font-size: rem(30px);
            font-weight: bold;
            // color: $baseTextColor;
            margin-bottom: 20px;
            text-align: left;

        }

        .login {

            .inputs {
                display: flex;
                flex-direction: column;

                input {
                    margin: 20px 0;
                    border: 1px solid $border-gray;
                    border-radius: 5px;
                    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.16);
                    font-size: rem(14px);
                    padding: 14px 0 14px 30px;
                }
            }

            .buttons {
                display: flex;
                justify-content: space-between;
                margin-top: 40px;
                align-items: center;
                @include media('<400px') {
                    flex-direction: column;
                    margin-top: 20px;
                }

                a {
                    text-decoration: none;
                    color: $peacock-blue;
                    @include media('<400px') {
                        flex-direction: column;
                        margin-top: 20px;
                    }
                }

                button {
                    color: white;
                    font-weight: bold;
                    font-size: rem(18px);
                    background-color: $peacock-blue;
                    padding: 12px 50px;
                    border-radius: 30px;
                    border: 1px solid $peacock-blue;
                    transition: 300ms all ease-in;
                    cursor: pointer;

                    &:hover {
                        color: $peacock-blue;
                        background-color: white;
                    }
                }
            }
        }
    }

</style>
